import React from 'react'
import PreviewTop from './previewTop'
import PreviewFrame from './previewFrame'
import './textPreview.css'

class TextPreview extends React.Component {
    constructor(props) {
        super(props)
    }

    handleClosePreview = (e) => {
        this.props.closePreviewPage(e);
    };

    handleClickSelf= (e) => {
        e.nativeEvent.stopImmediatePropagation();
    };

    handleOpenConsult = () => {
        this.props.openConsult();
    };

    handleOpenEdit = () => {
        this.props.editContent();
    };

    render(){
        let display = this.props.visible?'inline':'none';
        return(
            <div onClick={this.handleClickSelf} style={{display}} className='div_content'>
                <PreviewTop editContent={this.handleOpenEdit} openConsult={this.handleOpenConsult} closePreview={this.handleClosePreview}/>
                <PreviewFrame content={this.props.fileContent}/>
            </div>
        );
    }
}

export default TextPreview